import { AppErrorKind } from "./appErrorKind";

export function getAppError(
	error: Error,
	type: AppErrorKind,
	description: string,
): string {
	return `[${type} ERROR]: ${description} (${error.message})`;
}
